module.exports = __webpack_public_path__ + "static/media/painting.1e69d332.png";